export enum Api {
  GetUserSig = '/ns-service-app-calcul/monitorRoomGroup/getUserSig',
  UpdateImage = '/ns-service-app-calcul/monitorRoom/updateImage'
}
export function getUserSig(params: { roomCode: string }) {
  return http.post<{ userSig: string; roomCode: string }>({
    url: Api.GetUserSig,
    data: params
  })
}

export function updateMonitorRoomImage(params: {
  actiLinkId: string | number
  accountId: string | number
  roomGroupId: string | number
  imageUrl: string
  position: 'master' | 'desk' | 'slave'
}) {
  return http.post({
    url: Api.UpdateImage,
    data: params
  })
}
